// src/analytics/AnalyticsRouteTracker.jsx
// ✅ Tracks page_view events on every route change (SPA navigation)
// ✅ META PIXEL ADDED: PageView tracking on route changes

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPixelPageView } from "./metaPixel";

export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // GA loads only after consent, so gtag may not exist yet
    if (typeof window.gtag !== "function") return;

    // GA4 PageView
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
    });

    // Meta Pixel PageView
    trackPixelPageView();
  }, [location.pathname, location.search]);

  return null;
}